import * as React from "react";
import type { SVGProps } from "react";
const SvgMonitorMobbile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.95 6.74c0-3.37-.84-4.21-4.21-4.21H6.21C2.84 2.53 2 3.37 2 6.74v6c0 3.37.84 4.21 4.21 4.21H10v4.52H6.74M2 12.95h8m7.244 5.3h.01M22 12.8v5.71c0 2.37-.59 2.96-2.96 2.96h-3.55c-2.37 0-2.96-.59-2.96-2.96V12.8c0-2.37.59-2.96 2.96-2.96h3.55c2.37 0 2.96.59 2.96 2.96"
    />
  </svg>
);
export default SvgMonitorMobbile;
